import restClient from "../restClient";

const endpoint = "/sales-locations";

export const getSalesLocations = async (page, pageSize, search) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        "pagination[page]": page,
        "pagination[pageSize]": pageSize,
        "populate": "*"
      }
    };
    
    if (search) {
      config.params.search = search.toLowerCase().replace(/\s+/g, '-');
    }

    const response = await restClient.get(endpoint, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getSalesLocation = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createSalesLocation = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateSalesLocation = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`${endpoint}/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteSalesLocation = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


